import React, {Fragment} from 'react';
import i18n from '../../../utilities/i18n';
import {Checkbox} from '../../checkboxes/checkbox';
import {Button, ButtonType} from '../../button/button';
import {useHistory} from 'react-router-dom';
import {TasklistIcon} from '@navikt/aksel-icons';

const VelgArt = (props) => {
  const history = useHistory();
  if (props.eksisterendeLisenser.length === 4) {
    history.push( props.redirectURL);
  }
  return (
    <Fragment>
      <h2 className='pageHeading'>{i18n.t('lisensRegistrering:hvilkeArter')}{props.jaktaar}</h2>
      <hr/>
      <p className='stepCount'>{i18n.t('lisensRegistrering:steg1')}</p>
      {props.eksisterendeLisenser.length !== 0 &&
        <div className='lisensListe'>
          <h3>{i18n.t('lisensRegistrering:tidligereLisenser')}</h3>
          {props.eksisterendeLisenser
                    .map((art) => (
                      <div key={art.artId} className='artsListeElement'>
                        <Checkbox checkboxId={art.artId}
                                  text={i18n.t('felles:' + art.beskrivelse)}
                                  disabled={true}
                                  isChecked={true}/>
                      </div>))}
        </div>}
      {props.eksisterendeLisenser.length === 0 ?
        <h3>{i18n.t('lisensRegistrering:velg')}</h3>
                :
        <h3>{i18n.t('lisensRegistrering:velgMer')}</h3>}
      <div className='lisensListe'>
        {props.lisensArter
                    .filter((art) => !props.eksisterendeLisenser.includes(art))
                    .map((art) => (
                      <div key={art.artId} className='artsListeElement'>
                        <Checkbox checkboxId={art.artId}
                                  text={i18n.t('felles:' + art.beskrivelse)}
                                  isChecked={art.arter}
                                  onChange={() => {
                                          props.checkboxToggle(art);
                                      }}/>
                      </div>
                    ))}
      </div>
      {props.lisensArter.filter(art => art.arter === 1).filter(art => !props.eksisterendeLisenser.includes(art)).length > 0 ?
        <Button type={ButtonType.PRIMARY}
                onClick={props.nextPage}
                icon={<TasklistIcon fontSize="1.5rem"/>}
                buttonId="saveRegButton">
          {i18n.t('lisensRegistrering:registrerValgt')}</Button>
                :
        <Button type={ButtonType.PRIMARY}
                disabled={true}
                onClick={() => {}}
                // Intentionaly empty
                icon={<TasklistIcon fontSize="1.5rem"/>}
                buttonId="saveRegButton">
          {i18n.t('lisensRegistrering:registrerValgt')}
        </Button>}

      <Button type={ButtonType.SIMPLE}
              onClick={props.abort}
              buttonId="abortButton">
        {i18n.t('lisensRegistrering:avbryt')}
      </Button>
      <hr/>
    </Fragment>
  );
};

export default VelgArt;
